module.exports = __webpack_public_path__ + "img/bubble.b69e09be.png";